import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ComponentType } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routes } from "src/config/routes";
import { useMe } from "src/queries/useMe";
import { Loader } from "./Loader";

interface ProtectedRouteProps {
  component: ComponentType;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component,
}) => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth0();
  const { isError: meError, isLoading } = useMe();
  const navigate = useNavigate();
  const location = useLocation();

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="page-layout">
        <Loader />
      </div>
    ),
  });

  if (isLoading || isAuthLoading) {
    return <Loader />;
  }

  const mobileAccessibleRoutes = new Set([
    Routes.MOBILE,
    Routes.LOGIN,
    Routes.HOME_PAGE,
    Routes.SETTINGS,
    ...(location.pathname.includes(Routes.RESOURCES)
      ? [location.pathname]
      : []),
  ]);

  if (
    meError &&
    isAuthenticated &&
    !mobileAccessibleRoutes.has(location.pathname)
  ) {
    navigate(Routes.NOT_ALLOWED);
  }

  return <Component />;
};
